export const STORE_PURCHASE_KEYS = {
  ERROR_TITLE: 'store_purchase_error_title',
  FAILED: 'store_purchase_failed',
  INSUFFICIENT_FUNDS: 'store_purchase_error_insufficient_funds',
  LIMIT_REACHED: 'store_purchase_error_limit_reached',
  PURCHASE_LIMITATION: 'store_purchase_error_purchase_limitation',
  SOLD_OUT: 'store_purchase_error_sold_out',
  SUCCESS: 'store_purchase_success',
  SUCCESS_TITLE: 'store_purchase_success_title',
};

const ERROR_CODE_KEYS = {
  11000: STORE_PURCHASE_KEYS.INSUFFICIENT_FUNDS,
  11006: STORE_PURCHASE_KEYS.LIMIT_REACHED,
  11009: STORE_PURCHASE_KEYS.SOLD_OUT,
  11011: STORE_PURCHASE_KEYS.INSUFFICIENT_FUNDS,
  11012: STORE_PURCHASE_KEYS.INSUFFICIENT_FUNDS,
  11014: STORE_PURCHASE_KEYS.PURCHASE_LIMITATION,
};

const toToast = ({ isSuccess, message, rawText = false, title }) => ({
  data: { pinnedTop: true, ...(rawText ? { rawText: true } : {}) },
  isSuccess,
  message,
  status: isSuccess ? 'success' : 'error',
  title,
  type: 'toast',
});

export const resolvePurchaseToast = result => {
  const code = result?.err_code ?? result?.errCode;

  if (code == null || Number(code) === 0) {
    return toToast({
      isSuccess: true,
      message: STORE_PURCHASE_KEYS.SUCCESS,
      title: STORE_PURCHASE_KEYS.SUCCESS_TITLE,
    });
  }

  const serverMessage = (result?.err_message ?? result?.errMsg ?? '').trim();

  if (serverMessage) {
    return toToast({
      isSuccess: false,
      message: serverMessage,
      rawText: true,
      title: STORE_PURCHASE_KEYS.ERROR_TITLE,
    });
  }

  return toToast({
    isSuccess: false,
    message: ERROR_CODE_KEYS[Number(code)] || STORE_PURCHASE_KEYS.FAILED,
    title: STORE_PURCHASE_KEYS.ERROR_TITLE,
  });
};

export const FAILED_PURCHASE_TOAST = toToast({
  isSuccess: false,
  message: STORE_PURCHASE_KEYS.FAILED,
  title: STORE_PURCHASE_KEYS.ERROR_TITLE,
});
